import { SUPPORTED_LANGUAGES } from '@shared/core/localized-defaults'
import { MESSAGE_TEMPLATE_MESSAGE_BODY_MAX, MESSAGE_TEMPLATE_VARCHAR_MAX } from '@shared/core/message-templates'
import * as yup from 'yup'

const varcharTooLong = `Must be at most ${MESSAGE_TEMPLATE_VARCHAR_MAX} characters`
const messageBodyTooLong = `Must be at most ${MESSAGE_TEMPLATE_MESSAGE_BODY_MAX} characters`

export const schema = yup
  .object()
  .shape({
    template_name: yup.string().required('Template name is required').max(MESSAGE_TEMPLATE_VARCHAR_MAX, varcharTooLong),
    sender_name: yup.string().nullable().max(MESSAGE_TEMPLATE_VARCHAR_MAX, varcharTooLong),
    location: yup.string().nullable().max(MESSAGE_TEMPLATE_VARCHAR_MAX, varcharTooLong),
    confirmation_enabled: yup.boolean(),
    confirmation_message: yup.string().when('confirmation_enabled', {
      is: true,
      then: (schema) =>
        schema.required('Message is required').max(MESSAGE_TEMPLATE_MESSAGE_BODY_MAX, messageBodyTooLong),
      otherwise: (schema) => schema.nullable().max(MESSAGE_TEMPLATE_MESSAGE_BODY_MAX, messageBodyTooLong),
    }),
    confirmation_offsets: yup
      .array()
      .of(yup.number())
      .when('confirmation_enabled', {
        is: true,
        then: (schema) => schema.min(1, 'At least one timing is required'),
        otherwise: (schema) => schema.nullable(),
      }),
    reminder_enabled: yup.boolean(),
    reminder_message: yup.string().when('reminder_enabled', {
      is: true,
      then: (schema) =>
        schema.required('Message is required').max(MESSAGE_TEMPLATE_MESSAGE_BODY_MAX, messageBodyTooLong),
      otherwise: (schema) => schema.nullable().max(MESSAGE_TEMPLATE_MESSAGE_BODY_MAX, messageBodyTooLong),
    }),
    reminder_offsets: yup
      .array()
      .of(yup.number())
      .when('reminder_enabled', {
        is: true,
        then: (schema) => schema.min(1, 'At least one timing is required'),
        otherwise: (schema) => schema.nullable(),
      }),
    follow_up_enabled: yup.boolean(),
    follow_up_message: yup.string().when('follow_up_enabled', {
      is: true,
      then: (schema) =>
        schema.required('Message is required').max(MESSAGE_TEMPLATE_MESSAGE_BODY_MAX, messageBodyTooLong),
      otherwise: (schema) => schema.nullable().max(MESSAGE_TEMPLATE_MESSAGE_BODY_MAX, messageBodyTooLong),
    }),
    follow_up_offsets: yup
      .array()
      .of(yup.number())
      .when('follow_up_enabled', {
        is: true,
        then: (schema) => schema.min(1, 'At least one timing is required'),
        otherwise: (schema) => schema.nullable(),
      }),
    is_default: yup.boolean().nullable(),
    default_for_calendars: yup.array().of(yup.string()).nullable(),
    language: yup
      .mixed()
      .oneOf([...SUPPORTED_LANGUAGES, null])
      .nullable(),
  })
  .test('at-least-one-message-type', 'At least one message type must be enabled', function (value) {
    return value.confirmation_enabled || value.reminder_enabled || value.follow_up_enabled
  })
